import React from 'react';
import PropTypes from 'prop-types';
import { StructuredText } from 'react-datocms';
import { renderRule, isInlineNode } from 'datocms-structured-text-utils';
import HtmlBlock from '../../components/htmlBlock/htmlBlock';
import RenderComponents from '../../lib/renders/renderComponents';
import Link from '../../components/link/link';

/**
 * StructuredText
 * 
 */
const StructuredTextComponent = ({className, data, ...other}) => {
  return (
      <div className={`structuredText ${className}`} {...other}>
        <StructuredText 
          data={data}
          customRules={[
            renderRule(
              //Run all nodes through the HTMLBlock component for decode and sanitize
              isInlineNode,
              ({ adapter: { renderNode }, node, children, key, ancestors }) => {
              //Render Inline Links
              if(children && node.type==='link'){
                // return renderNode('a', { key, href:node.url, target: node.meta?.target ? node.meta?.target : '_self' }, children);
                return <Link icon={false} key={key} className={'basic'} href={node.url} target={node.meta?.target ? node.meta?.target : '_self'} >{children}</Link>
              }
              if(node.value && node.value !== ''){
                return <HtmlBlock tag={`${node.type}`} key={key} data={node.value}/>;
              }
            },
          ),
          ]}
          renderBlock={({record})=>{
            let classIn;
            switch(record?.typename){
              case 'DatoCmsComponentLink':
                classIn = 'linkwrap'
              break;
              case 'DatoCmsComponentMobileDesktopVersion':
                classIn = 'constrain'
              break;
              default:
              break;
            }
            return <div className={classIn}><RenderComponents data={[record]} className={record.__typename === 'DatoCmsComponentLink' ? 'link--featured--primary' : ''} /></div>
          }}
        />
      </div>
  )
}

export default StructuredTextComponent;

StructuredTextComponent.propTypes = {
  className: PropTypes.string,
};